import React from 'react';

export default props => {
    return (
        <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L4.5 4.5M8 8L4.5 4.5M4.5 4.5L8 1M4.5 4.5L1 8" stroke="#EB5757" stroke-width="2"/>
        </svg>
    );
};
